export default {
  'article.guide.title': 'Guide USFans Spreadsheet : organisez et achetez tout le catalogue',
  'article.guide.desc':
    "Un guide complet du USFans Spreadsheet — comment il organise les catégories de mode, comment naviguer efficacement et des conseils d'achat malins.",
  'article.guide.category': 'Guide complet',

  'article.meta.title': 'Guide USFans Spreadsheet : organisez et achetez tout le catalogue',
  'article.meta.description':
    "Découvrez comment le USFans Spreadsheet organise chaussures, sweats, maillots et plus en catégories claires. Un guide pratique avec conseils, comparaisons et FAQ.",
  'article.breadcrumb.home': 'Accueil',
  'article.breadcrumb.current': 'Guide USFans Spreadsheet',

  'article.author': 'Équipe éditoriale USFans Spreadsheet',
  'article.updated': 'Dernière mise à jour',
  'article.minutes': 'min de lecture',

  'article.intro.title': 'Introduction',
  'article.intro.p1':
    "Faire ses achats dans un grand catalogue de mode peut être écrasant, surtout quand les produits sont répartis sur des dizaines de pages. Le USFans Spreadsheet a été créé pour résoudre exactement ce problème : il rassemble chaussures, sweats, t-shirts, vestes, maillots, accessoires et plus dans une vue organisée et facile à parcourir.",
  'article.intro.p2':
    "Dans ce guide, nous expliquons ce qu'est le USFans Spreadsheet, comment fonctionne son système de catégories et comment l'utiliser pour trouver le bon article plus vite — sans défilement interminable ni suppositions.",

  'article.what.title': "Qu'est-ce que le USFans Spreadsheet ?",
  'article.what.p1':
    "Le USFans Spreadsheet est un catalogue structuré qui regroupe une large gamme de vêtements de mode et de produits pour fans dans des catégories claires et logiques. Plutôt que de parcourir un flux de produits désorganisé, les visiteurs peuvent aller directement à la catégorie qui les intéresse : chaussures, sweats et pulls, t-shirts, vestes, pantalons et shorts, couvre-chefs, ensembles, sous-vêtements, maillots, accessoires, sacs, ceintures, parfums et autres articles.",
  'article.what.p2':
    "Chaque catégorie mène à une section dédiée de la boutique principale, vous arrivez donc toujours exactement là où il faut. Cette structure rend le USFans Spreadsheet utile à la fois comme outil de navigation rapide et comme référence de planification pour votre prochain achat.",

  'article.categories.title': 'Comprendre le système de catégories',
  'article.categories.p1':
    "Le catalogue est organisé en quatorze catégories intuitives. Voici comment chacune vous aide à affiner votre recherche :",
  'article.categories.bullet1': 'Chaussures — baskets, chaussures décontractées et sportives.',
  'article.categories.bullet2': 'Hoodies/Sweats — pulls, hoodies et mailles confortables.',
  'article.categories.bullet3': 'T-shirts — t-shirts du quotidien dans diverses coupes et motifs.',
  'article.categories.bullet4': 'Vestes — vêtements d\'extérieur, des couches légères aux manteaux.',
  'article.categories.bullet5': 'Pantalons/Shorts — bas pour chaque saison et occasion.',
  'article.categories.bullet6': 'Couvre-chefs — casquettes, bonnets et autres accessoires de tête.',
  'article.categories.bullet7': 'Ensembles — tenues coordonnées regroupées.',
  'article.categories.bullet8': 'Sous-vêtements — basiques essentiels et sous-vêtements.',
  'article.categories.bullet9': 'Maillots — maillots d\'équipe et style sportif.',
  'article.categories.bullet10': 'Accessoires — petits articles qui complètent une tenue.',
  'article.categories.bullet11': 'Sacs — sacs à dos, cabas et options du quotidien.',
  'article.categories.bullet12': 'Ceintures — ceintures dans une gamme de styles.',
  'article.categories.bullet13': 'Parfums — fragrances pour usage personnel ou cadeau.',
  'article.categories.bullet14': 'Autres articles — tout ce qui ne correspond pas aux catégories ci-dessus.',

  'article.how.title': 'Comment parcourir le catalogue efficacement',
  'article.how.p1':
    "Commencez par identifier ce dont vous avez réellement besoin. Si vous cherchez un article précis, utilisez le menu déroulant ou les boutons de catégorie de la page d'accueil pour aller directement à cette section. Si vous explorez simplement, parcourez d'abord les catégories populaires.",
  'article.how.p2':
    "Une fois dans une catégorie, regardez toute la sélection avant de décider. Comparer quelques options dans la même catégorie — plutôt que de sauter entre des produits sans rapport — mène généralement à un meilleur choix et à moins de regrets.",
  'article.how.tip1': 'Utilisez les catégories au lieu de deviner les termes de recherche.',
  'article.how.tip2': 'Comparez quelques articles dans la même catégorie.',
  'article.how.tip3': 'Vérifiez la disponibilité et les détails avant de finaliser.',

  'article.comparison.title': 'USFans Spreadsheet vs navigation désorganisée',
  'article.comparison.p1':
    "La différence entre un catalogue organisé et une liste de produits désorganisée est significative. Le tableau ci-dessous résume la comparaison entre l'approche USFans Spreadsheet et d'autres façons de parcourir.",
  'article.comparison.col1': 'Approche',
  'article.comparison.col2': 'Organisation',
  'article.comparison.col3': 'Vitesse pour trouver',
  'article.comparison.col4': 'Meilleur cas d\'usage',
  'article.comparison.r1c1': 'USFans Spreadsheet',
  'article.comparison.r1c2': 'Élevée',
  'article.comparison.r1c3': 'Rapide',
  'article.comparison.r1c4': 'Achat structuré',
  'article.comparison.r2c1': 'Recherche aléatoire',
  'article.comparison.r2c2': 'Faible',
  'article.comparison.r2c3': 'Lente',
  'article.comparison.r2c4': 'Recherches ponctuelles rapides',
  'article.comparison.r3c1': 'Une seule longue liste',
  'article.comparison.r3c2': 'Moyenne',
  'article.comparison.r3c3': 'Moyenne',
  'article.comparison.r3c4': 'Inspiration en défilant',

  'article.tips.title': 'Conseils d\'achat malins',
  'article.tips.p1':
    "Un peu de préparation rend les achats en ligne plus fluides et plus sûrs. Gardez ces conseils pratiques à l'esprit en utilisant le USFans Spreadsheet :",
  'article.tips.tip1': 'Vérifiez les détails, les tailles et la disponibilité avant de commander.',
  'article.tips.tip2': 'Consultez les informations de livraison et de retour sur la boutique.',
  'article.tips.tip3': 'Gardez vos données de paiement privées et achetez uniquement sur la boutique officielle.',
  'article.tips.tip4': 'Revenez au catalogue quand de nouveaux articles ou saisons arrivent.',

  'article.faq.title': 'Questions fréquentes',
  'article.faq.q1': "Qu'est-ce que le USFans Spreadsheet ?",
  'article.faq.a1':
    "C'est un catalogue organisé qui regroupe vêtements de mode et produits pour fans en catégories claires, rendant plus rapide la recherche de chaussures, sweats, maillots, accessoires et plus.",
  'article.faq.q2': 'Comment trouver un produit précis rapidement ?',
  'article.faq.a2':
    "Utilisez le menu déroulant ou les boutons de catégorie de la page d'accueil pour aller directement à la section souhaitée.",
  'article.faq.q3': 'Le USFans Spreadsheet est-il une boutique ?',
  'article.faq.a3':
    "C'est une ressource informative et de navigation. Les achats sont finalisés sur la boutique principale vers laquelle il renvoie.",
  'article.faq.q4': 'À quelle fréquence le catalogue est-il mis à jour ?',
  'article.faq.a4':
    'Les catégories restent alignées sur la boutique principale, donc les nouveautés et articles de saison apparaissent dès qu\'ils sont disponibles.',

  'article.cta.title': 'Prêt à parcourir tout le catalogue ?',
  'article.cta.p1':
    "Maintenant que vous comprenez le fonctionnement du USFans Spreadsheet, revenez à la page d'accueil pour explorer les catégories, ou visitez directement la boutique pour commencer vos achats.",
  'article.cta.back': "Retour à l'accueil",
  'article.cta.store': 'Visiter la boutique',

  'article.disclaimer':
    "Avertissement : USFanslink.makeup est une ressource informative indépendante. La disponibilité, les prix et les politiques des produits sont gérés par la boutique liée et peuvent changer. Vérifiez toujours les détails importants directement sur la boutique avant d'acheter.",
};